import { NgModule } from "@angular/core";
import { TableModule } from "primeng/table";
import { ProgressBar } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TabsModule } from 'primeng/tabs';
import { ButtonModule } from "primeng/button";
import { FieldsetModule } from 'primeng/fieldset';
import { ImageModule } from 'primeng/image';
import { CardModule } from 'primeng/card';
import { PopoverModule } from 'primeng/popover';
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { BadgeModule } from 'primeng/badge';
import { CheckboxModule } from 'primeng/checkbox';
@NgModule({
  declarations: [],
  imports: [
    BadgeModule,
    CardModule,
    CheckboxModule,
    FieldsetModule,
    ImageModule,
    ProgressBar,
    TableModule,
    ProgressSpinnerModule,
    PopoverModule,
    TabsModule,
    ButtonModule,
    ConfirmDialogModule,
  ],
  exports: [
    BadgeModule,
    CardModule,
    CheckboxModule,
    FieldsetModule,
    ImageModule,
    ProgressBar,
    TableModule,
    ProgressSpinnerModule,
    PopoverModule,
    TabsModule,
    ButtonModule,
    ConfirmDialogModule,
  ]
})
export class ViewPrimengModule { }
